// import React from 'react';
// import { Container, Row, Col } from 'react-bootstrap';

// export function Contact() {
//   return (
//     <div style={{ 
//       backgroundImage: `url('./img/IMG-20240220-WA0003.jpg')`,
//       backgroundSize: 'contain',
//       minHeight: '100vh',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       backgroundRepeat: 'no-repeat',
//       backgroundPosition: 'center',
//       backgroundAttachment: 'fixed',
//       backgroundColor: 'black'
//     }}>
//       <Container style={{ 
//         backgroundColor: 'rgba(255, 255, 255, 0.8)',
//         padding: '30px',
//         borderRadius: '15px',
//         boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.3)',
//         fontFamily: "'Playfair', serif", 
//         fontSize: '22px',
//         lineHeight: '1.6',
//         opacity: '0.8',
//       }}>
//        <Row>
//   <Col md={{ span: 6, offset: 3 }} style={{ textAlign: 'center' }}>
//     <h1 style={{ marginBottom: '20px' }}>Contact</h1>
//     <p>For inquiries or collaborations, feel free to contact us:</p>
//     <p>
//       Email: <a href="mailto:dinastojilkovic@gmail.com" style={{ textDecoration: 'none', color: 'black' }}>dinastojilkovic@gmail.com</a>
//     </p>
//   </Col>
// </Row>
//       </Container>
//     </div>
//   );
// }



import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export function Contact() {
  return (
    <div
      style={{
        backgroundImage: `url('./img/IMG-20240220-WA0003.jpg')`,
        backgroundSize: 'contain',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundColor: 'black',
      }}
    >
      <Container
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: '30px',
          borderRadius: '15px',
          boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.3)',
          fontFamily: "'Playfair', serif",
          fontSize: '22px',
          lineHeight: '1.6',
          opacity: '0.8',
        }}
      >
        <Row>
          <Col md={{ span: 6, offset: 3 }} style={{ textAlign: 'center' }}>
            <h1 style={{ marginBottom: '20px' }}>Contact</h1>
            <p>For inquiries or collaborations, feel free to contact us:</p>
            <p>
              Email:{' '}
              <a
                href="mailto:dinastojilkovic@gmail.com"
                style={{ textDecoration: 'none', color: 'black' }}
              >
                dinastojilkovic@gmail.com
              </a>
            </p>
            <div>
              {/* YouTube Icon */}
              <a
                href="https://www.youtube.com/@DinaStojilkovic6069"
                target="_blank"
                rel="noopener noreferrer"
                style={{ margin: '0 10px', color: 'red' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M23.499 6.203a3.041 3.041 0 0 0-2.135-2.148C19.72 3.5 12 3.5 12 3.5s-7.72 0-9.364.555A3.041 3.041 0 0 0 .501 6.203C0 8.025 0 12 0 12s0 3.975.501 5.797a3.041 3.041 0 0 0 2.135 2.148C4.28 20.5 12 20.5 12 20.5s7.72 0 9.364-.555a3.041 3.041 0 0 0 2.135-2.148C24 15.975 24 12 24 12s0-3.975-.501-5.797zM9.75 15.315V8.685L15.315 12 9.75 15.315z" />
                </svg>
              </a>
              {/* Instagram Icon */}
              <a
                href="https://www.instagram.com/dinastojilkovic/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ margin: '0 10px', color: '#C13584' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M7.75 2h8.5C19.873 2 22 4.127 22 7.75v8.5c0 3.623-2.127 5.75-5.75 5.75h-8.5C4.127 22 2 19.873 2 16.25v-8.5C2 4.127 4.127 2 7.75 2zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm7.5-3.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                </svg>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
